__turbopack_context__.v({
  "flagPlaceholder": "LXtETq_flagPlaceholder",
  "formGroupWrapper": "LXtETq_formGroupWrapper",
  "label": "LXtETq_label",
  "phoneInput": "LXtETq_phoneInput",
  "select": "LXtETq_select",
  "selectedValue": "LXtETq_selectedValue",
});
